//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Facet/Facet.SelectFacetedBodyList.js";
import "../GeometricUtilities/GeometricUtilities.BoundaryDefinitionBuilderList.js";
import "../no/FacetCollector.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AngleThreshold",1,0],[1,"Bodies",0,"SelectDisplayableObjectList",1],[0,"DecimateMethod",1,0],[1,"FacetBodies",0,"Facet.SelectFacetedBodyList",1],[0,"FacetCollector",1,"FacetCollector",0],[0,"IsEditCopy",1,0],[0,"IsLockBoundary",1,0],[0,"MinimumArea",1,0],[0,"Percentage",1,0],[1,"RegionList",0,"GeometricUtilities.BoundaryDefinitionBuilderList",1],[0,"Tolerance",1,0]],[],[]];
SPLM.Facet.DecimateFacetBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.DecimateFacetBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.DecimateFacetBodyBuilder.DecimateMethodType = Object.freeze({
    "ChordalDeviation" : "ChordalDeviation", "SmallestFacet" : "SmallestFacet", "Percentage" : "Percentage"});

export default SPLM;